module.exports = __webpack_public_path__ + "static/media/download.2871e7f4.svg";